// Shared blocks used by both the Privacy Policy and the Cookie Policy (source: iubenda, April 22, 2026).
import type { LegalSection } from './legal';

export const ownerDetails: string[] = [
  'Company Name: KAYS VENTURES FZCO',
  'Registered Office: Dubai Silicon Oasis, DDP, Building A1, Dubai, United Arab Emirates',
  'Phone Number: 00971 / 505254282',
  'Email Address: hey@superluxury.io',
  'Website: superluxury.io',
  'Managing Directors: Adrian Kays',
  'Trade License Number: 16239',
  'VAT Identification Number: Pending application',
  'Regulatory Authority: IFZA',
];

export const usageDataDefinition =
  "Information collected automatically through this Website (or third-party services employed in this Website), which can include: the IP addresses or domain names of the computers utilized by the Users who use this Website, the URI addresses (Uniform Resource Identifier), the time of the request, the method utilized to submit the request to the server, the size of the file received in response, the numerical code indicating the status of the server's answer (successful outcome, error, etc.), the country of origin, the features of the browser and the operating system utilized by the User, the various time details per visit (e.g., the time spent on each page within the Application) and the details about the path followed within the Application with special reference to the sequence of pages visited, and other parameters about the device operating system and/or the User's IT environment.";

export const definitionsSection: LegalSection = {
  heading: 'Definitions and legal references',
  paragraphs: [],
  subsections: [
    {
      heading: 'Personal Data (or Data)',
      paragraphs: [
        'Any information that directly, indirectly, or in connection with other information — including a personal identification number — allows for the identification or identifiability of a natural person.',
      ],
    },
    { heading: 'Usage Data', paragraphs: [usageDataDefinition] },
    {
      heading: 'User',
      paragraphs: ['The individual using this Website who, unless otherwise specified, coincides with the Data Subject.'],
    },
    { heading: 'Data Subject', paragraphs: ['The natural person to whom the Personal Data refers.'] },
    {
      heading: 'Data Processor (or Processor)',
      paragraphs: [
        'The natural or legal person, public authority, agency or other body which processes Personal Data on behalf of the Controller, as described in this privacy policy.',
      ],
    },
    {
      heading: 'Data Controller (or Owner)',
      paragraphs: [
        'The natural or legal person, public authority, agency or other body which, alone or jointly with others, determines the purposes and means of the processing of Personal Data, including the security measures concerning the operation and use of this Website. The Data Controller, unless otherwise specified, is the Owner of this Website.',
      ],
    },
    {
      heading: 'This Website (or this Application)',
      paragraphs: ['The means by which the Personal Data of the User is collected and processed.'],
    },
    {
      heading: 'Service',
      paragraphs: ['The service provided by this Website as described in the relative terms (if available) and on this site/application.'],
    },
    {
      heading: 'European Union (or EU)',
      paragraphs: [
        'Unless otherwise specified, all references made within this document to the European Union include all current member states to the European Union and the European Economic Area.',
      ],
    },
    {
      heading: 'Cookie',
      paragraphs: ["Cookies are Trackers consisting of small sets of data stored in the User's browser."],
    },
    {
      heading: 'Tracker',
      paragraphs: [
        'Tracker indicates any technology - e.g Cookies, unique identifiers, web beacons, embedded scripts, e-tags and fingerprinting - that enables the tracking of Users, for example by accessing or storing information on the User’s device.',
      ],
    },
  ],
};

export const legalInformationSection: LegalSection = {
  heading: 'Legal information',
  paragraphs: ['This policy relates solely to this Website, if not stated otherwise within this document.'],
};
